/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useEffect, useState, useContext } from 'react';
import { CardContent, CardHeader, Container, Expandable, IconsContainer, UpdateButton, ContentTextArea, ButtonContainer, CancelButton } from './styles'
import PropTypes from 'prop-types';
import Icon from 'components/Icon';
import { TextArea2 } from 'components/Dialog';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';

const propTypes = {
  title: PropTypes.string.isRequired,
  idOperation: PropTypes.number.isRequired,
};
export default function NotesAccordion(props) {
  const [expanded, setExpanded] = useState(false);
  const [expanding, setExpanding] = useState(false);
  const [collapsing, setCollapsing] = useState(false);
  const [beforeCollapsing, setBeforeCollapsing] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState("");
  const [notes, setNotes] = useState("");
  const [shouldRender, setShouldRender] = useState(false);

  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();

  const accordionState = (state) => {
    setExpanding(false);
    setCollapsing(false);
    setBeforeCollapsing(false);
    setExpanded(state);
  };

  const accordionAnimation = (state) => {
    setExpanded(false);
    if (state && !expanded) {
      setExpanding(true);
      setTimeout(() => accordionState(true), 100);
    } else if (!state && expanded) {
      setBeforeCollapsing(true);
      setTimeout(() => {
        setCollapsing(true);
        setTimeout(() => accordionState(false), 100)
      }, 10);
    }
  };

  function handleUpdateNotes() {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestOperationNotesUpdate(props.idOperation, value)
      .then(() => {
        loading.stop();
        setIsEditing(false);
        setValue("")
        handleGetNotes()
      })
      .catch((error) => {
        loading.stop();
        mc.error(`There was an error while fetching your data: ${handleUpdateNotes.name}\n` + error);
        console.error('fitPostSummary - Error:', error);
      });
  };

  function handleGetNotes() {
    if (props.idOperation) {
      fitinsur.setAuthToken(authContext.token);
      fitinsur.requestOperationNotes(props.idOperation)
        .then(response => response.json()).then(data => {
          setNotes(data.ret_value.notes)
          setShouldRender(data.ret_value.hasQuestions)
        })
        .catch((error) => {
          mc.error(`There was an error while fetching your data: ${handleGetNotes.name}\n` + error);
          console.error('fitPostSummary - Error:', error);
        });
    }
  };

  useEffect(() => {
    handleGetNotes();
  }, [props.idOperation])

  if (shouldRender) {
    return (
      <Container>
        <CardHeader >
          <div>
            {props.title}
          </div>
          <IconsContainer>
            <Icon
              name={isEditing ? "add-disabled" : "add"} 
              className="icon-add"
              onClick={() => {
                setIsEditing(true)
                setExpanded(true)
              }}
              disabled={isEditing}
              style={{ cursor: isEditing ? "not-allowed" : "pointer" }}
            />
            <Icon
              className={(!expanded || collapsing) && !expanding ? 'closed' : ''}
              name="arrowup"
              onClick={() => accordionAnimation(!expanded)}
            />
          </IconsContainer>
        </CardHeader>
        <CardContent className={expanded ? 'expanded' : beforeCollapsing ? 'before-collapsing' : (collapsing ? 'collapsing' : (expanding ? 'expanding' : ''))} >
          <Expandable>
            <ContentTextArea>
              <TextArea2
                value={isEditing ? value : notes}
                onChange={(e) => setValue(e.target.value)}
                disabled={!isEditing}
              />
              {isEditing
                ? (
                  <ButtonContainer>
                    <CancelButton
                      type="submit"
                      onClick={() => {
                        setIsEditing(false)
                        setValue("")
                      }}
                    >
                      CANCEL
                    </CancelButton>
                    <UpdateButton type="submit" onClick={() => handleUpdateNotes()}>UPDATE</UpdateButton>
                  </ButtonContainer>
                ) : null
              }

            </ContentTextArea>
          </Expandable>
        </CardContent>
      </Container>
    )
  } else {
    return <div />
  };
}

NotesAccordion.propTypes = propTypes;
